<template>
    <div class="row justify-content-center">
        <div class="col-md-7 col-11">
            <card>
                <template slot="header">
                    New Event
                </template>
                <form class="form-horizontal">
                    <!-- NAME -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Name *</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="event.name"/>
                            </div>
                        </div>
                    </div>
                    <!-- START DATE -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Start Date *</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-date-picker
                                    v-model="event.startDate"
                                    type="datetime"/>
                            </div>
                        </div>
                    </div>
                    <!-- END DATE -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">End Date *</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-date-picker
                                    v-model="event.endDate"
                                    type="datetime"/>
                            </div>
                        </div>
                    </div>
                    <!-- COUNTRY -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Country</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-select v-model="event.country" placeholder="Country" filterable>
                                    <el-option
                                        v-for="(country, index) in countries"
                                        :key="`country-${index}`"
                                        :label="country.name"
                                        :value="country.code"/>
                                </el-select>
                                <div class="form-text">Select the country, the region and the city where your event will be taking place.</div>
                            </div>
                        </div>
                    </div>
                    <!-- LOGO -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Logo</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <input
                                    type="file"
                                    id="logo-upload"
                                    @change="uploadLogo"/>
                                <label for="logo-upload">
                                    <el-button>Choose File</el-button>
                                </label>
                                <div v-if="logoProgress !== 100">
                                    <el-progress :percentage="logoProgress"/>
                                </div>
                                <div
                                    v-else-if="event.logo && event.logo._id"
                                    class="form-text">
                                        <img :src="baseUrl + event.logo.path" width="100px"/>
                                </div>
                                <div
                                    v-else
                                    class="form-text">
                                        Upload a logo to identify your event.
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- BANNER -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Banner</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <input
                                    type="file"
                                    id="logo-upload"
                                    @change="uploadBanner"/>
                                <label for="logo-upload">
                                    <el-button>Choose File</el-button>
                                </label>
                                <div v-if="bannerProgress !== 100">
                                    <el-progress :percentage="bannerProgress"/>
                                </div>
                                <div
                                    v-else-if="event.banner && event.banner._id"
                                    class="form-text">
                                    <img :src="baseUrl + event.banner.path" width="100px"/>
                                </div>
                                <div
                                    v-else
                                    class="form-text">
                                        Select a banner image to identify your event in event calendars and social media
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- LANGUAGE -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Language</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-select v-model="event.language">
                                    <el-option
                                        v-for="(language, index) in languages"
                                        :key="`language-${index}`"
                                        :label="language.name"
                                        :value="language.code"/>
                                </el-select>
                                <div class="form-text">Choose language for you event. default texts in the website and mailings will appear in this language.</div>
                            </div>
                        </div>
                    </div>
                    <!-- ADDRESS -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Address</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <gmap-autocomplete
                                    @place_changed="setMapPlace"
                                    class="w-100"/>
                                <div class="form-text">What’s the exact address of your event?</div>
                            </div>
                        </div>
                    </div>
                    <!-- LOCATION -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Location</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <!-- <el-input/> -->
                                <div class="form-text">Locate your event in the map.</div>
                                <gmap-map
                                    @click="selectLocation"
                                    :center="mapOptions.center"
                                    :zoom="4"
                                    :options="mapOptions"
                                    style="width: 100%; height: 300px; margin-top: 10px">
                                        <gmap-marker
                                            v-if="event.location.lat && event.location.lng"
                                            :position="event.location"/>
                                </gmap-map>
                            </div>
                        </div>
                    </div>
                    <!-- Description -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Description</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="event.description" type="textarea" rows="10"/>
                                <div class="form-text">Enter a short description for your event.</div>
                            </div>
                        </div>
                    </div>
                    <!-- Keywords -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Keywords</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="event.keywords"/>
                                <div class="form-text">Enter keywords related to your event to help search engines find them. separate keywords by commas.</div>
                            </div>
                        </div>
                    </div>
                    <!-- Notification Email -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Notification E-Mail</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="event.notificationEmail"/>
                                <div class="form-text">E-Mail address to receive notifications.</div>
                            </div>
                        </div>
                    </div>
                    <!-- Online payment processing fee -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Online Payment Processing Fee</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input
                                    type="number"
                                    min="0"
                                    max="100"
                                    v-model="event.onlinePaymentProcessingFee"/>
                            </div>
                        </div>
                    </div>
                    <!-- Paypal Client ID -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Paypal Client ID</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="event.paypalClientID"/>
                            </div>
                        </div>
                    </div>
                    <!-- Paypal Sandbox Client ID -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Paypal Sandbox Client ID</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="event.paypalSandboxClientId"/>
                            </div>
                        </div>
                    </div>
                    <!-- Paypal Sandbox Mode -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Paypal Sandbox Mode</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-checkbox v-model="event.paypalSandboxMode" class="mt-2"/>
                            </div>
                        </div>
                    </div>
                    <!-- Allow Cash Payment -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Allow Cash Payment</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-checkbox v-model="event.allowCash" class="mt-2"/>
                            </div>
                        </div>
                    </div>
                    <!-- Send E-Mails -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Send E-Mails</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-checkbox v-model="event.sendEmails"/>
                            </div>
                        </div>
                    </div>
                    <!-- Allow Payment Deposit -->
                    <div class="row">
                        <label class="col-sm-2 col-form-label">Allow Payment Deposit</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-checkbox v-model="event.allowDeposit" class="mt-2"/>
                            </div>
                        </div>
                    </div>
                    <!-- Deposit Amount -->
                    <div v-if="event.allowDeposit" class="row">
                        <label class="col-sm-2 col-form-label">Deposit Amount</label>
                        <div class="col-sm-10">
                            <div class="form-group">
                                <el-input v-model="event.depositAmount"/>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="d-flex justify-content-end">
                    <el-button
                        type="primary"
                        class="btn btn-primary"
                        :loading="saving"
                        @click="submit()">
                            Create
                    </el-button>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import countries from '@/assets/js/countries'
import languages from '@/assets/js/languages'

export default {
    computed: {
        ...mapState([
            'baseUrl'
        ])
    },
    data () {
        return {
            event: {
                name: '',
                startDate: null,
                endDate: null,
                language: '',
                country: '',
                address: '',
                logo: null,
                banner: null,
                website: '',
                location: {
                    lat: null,
                    lng: null
                },
                description: '',
                keywords: '',
                notificationEmail: '',
                allowCash: false,
                allowDeposit: false,
                depositAmount: 0,
                senderName: '',
                senderEmail: '',
                onlinePaymentProcessingFee: 0,
                paypalClientId: '',
                paypalSandboxClientId: '',
                paypalSandboxMode: false,
                sendEmails: true
            },
            countries,
            languages,
            mapOptions: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
                center: {
                    lat: 39.381266,
                    lng: -97.922211
                }
            },
            saving: false,
            logoProgress: 100,
            bannerProgress: 100,
            logoInterval: null,
            bannerInterval: null
        }
    },
    methods: {
        uploadLogo: async function (event) {
            this.logoProgress = 1
            this.logoInterval = setInterval(() => {
                if (this.logoProgress < 98) {
                    this.logoProgress += 1
                } else {
                    clearInterval(this.logoInterval)
                    this.logoInterval = null
                }
            }, 100)

            try {
                const response = await this.$store.dispatch('uploadFile', event.target.files[0])
                this.event.logo = response.data.file
            } catch (e) {
                console.log('error uploading logo')
            }

            clearInterval(this.logoInterval)
            this.logoInterval = null
            this.logoProgress = 100
        },
        uploadBanner: async function (event) {
            this.bannerProgress = 1
            this.bannerInterval = setInterval(() => {
                if (this.bannerProgress < 98) {
                    this.bannerProgress += 1
                } else {
                    clearInterval(this.bannerInterval)
                    this.bannerInterval = null
                }
            }, 100)

            try {
                const response = await this.$store.dispatch('uploadFile', event.target.files[0])
                this.event.banner = response.data.file
            } catch (e) {
                console.log('error uploading banner')
            }

            clearInterval(this.bannerInterval)
            this.bannerInterval = null
            this.bannerProgress = 100
        },
        selectLocation: function ({ latLng }) {
            let location = {
                lat: latLng.lat(),
                lng: latLng.lng()
            }

            this.mapOptions.center = location
            this.event.location = location
        },
        setMapPlace: function (data) {
            let location = {
                lat: data.geometry.location.lat(),
                lng: data.geometry.location.lng()
            }

            this.mapOptions.center = location
            this.event.location = location
        },
        submit: async function () {
            try {
                this.saving = true
                await this.$store.dispatch('create', {
                    path: 'events',
                    data: this.event
                })
                this.$router.push({ name: 'events' })
            } catch (e) {
                console.log('error saving event')
            }

            this.saving = false
        }
    }
}
</script>
